export enum RouteAction {
    Editar = 'editar',
    Visualizar = 'visualizar',
    Inserir = 'criar'
}

export enum LoginAction {
    TrocarSenha = 'trocarSenha',
    EsqueciMinhaSenha = "esqueciMinhaSenha"
}

export enum StatusEnum {
	Aprovado = 'Aprovado',
	Pendente = 'Pendente',
	Cancelado = 'Cancelado',
}
